import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../../core/helpers/default';

const name = 'donationView';

const reducersKeys = {
  getDonationRequest: 'getDonationRequest',
  getDonationSuccess: 'getDonationSuccess',
  getDonationFailure: 'getDonationFailure',
};

const initialState = {
  donation: null,
  loaded: false,
  loading: false,
  error: null,
};

const donateFormEdit = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.getDonationRequest]: (state) => {
      state.loading = true;
      state.loaded = false;
    },
    [reducersKeys.getDonationSuccess]: (state, { payload }) => {
      state.donation = payload.donation;
      state.loading = false;
      state.loaded = true;
    },
    [reducersKeys.getDonationFailure]: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload.error;
    },
  },
});

export const donateFormEditReducers = createReducerNames(name, reducersKeys);
export const { actions } = donateFormEdit;

export default donateFormEdit.reducer;
